import { Injectable } from '@angular/core';
import { ApiService } from '../../common/api.service'
import { Observable } from 'rxjs';
import { SuccessResponse } from '../interfaces/api-response.interface';
import { ROUTES } from '../../server-route';

@Injectable({
  providedIn: 'root'
})
export class VisitTransmissionService extends ApiService{

  /**compulsory: uiState, uiDistrict, pincode,pageNo
filters -optional: address, userId, wishlistId, feedbackCategoryId
extra-optional: pageSize
*/
  public fetchVisitDetails(payLoad:any):Observable<SuccessResponse>{

    return this.get(ROUTES.FETCH_VISIT_DATA,{params:payLoad});
  }


  /**compulsory: uiState,uiDistrict,pincode,memKey
 */
  public fetchVisitHistory(payLoad:any):Observable<SuccessResponse>{
    
    return this.get(ROUTES.FETCH_VISIT_HISTORY,{params:payLoad});
  }


  //usage can be found in print-monitor/visited/visit.component.ts
  /** compulsory: uiState, uiDistrict, comments, lat, long, feedbackCategoryId, contact, memKey
  optional: visitState,visitDistrict,visitPincode, familyCode, phlFullName, landmark, workerIds
 */
  public addVisitData(payLoad:any):Observable<SuccessResponse>{

    return this.post(ROUTES.ADD_VISIT_DATA,{body:payLoad});
  }


  /** compulsory: uiState(String), uiDistrict, pincode, memKey, lat, long, userId
optional: all rest of the fields that are in add a visit
*/
  public updateVisitData(payLoad:any):Observable<SuccessResponse>{

    return this.patch(ROUTES.UPDATE_VISIT_DATA,{body:payLoad});
  }


  /**compulsory: uiState, uiDistrict */
  public fetchCategories(payLoad:any):Observable<SuccessResponse>{
    return this.get(ROUTES.FETCH_CATEGORIES,{params:payLoad});
  }


  /**compulsory: uiState,uiDistrict,pincode */
  public fetchVisitedUsers(payload:any):Observable<SuccessResponse>{
    return this.get(ROUTES.FETCH_VISITED_USERS,{params:payload});
  }


  /**compulsory: uiState,uiDistrict,memKey (serial no.) */
  public accessVisitedContact(payLoad:any):Observable<any>{
    return this.get(ROUTES.ACCESS_VISITED_CONTACT,{params:payLoad});
  }
}
